<template lang="pug">
  .container-main.container-padding
    c-header
      template(slot="left")
        h3 联系资料
    cBox.display-flex(v-loading="loading", :element-loading-fullscreen="false")
      el-form(:model="mchDetail", label-position="right", label-width="200px")
        template(v-if="mchDetail.type === 1")
          h4 公司联系方式
          el-row(:gutter="10")
            el-form-item(label="商户电话") 
              .width-680 {{ mchDetail.tel || '未填写' }}
            el-form-item(label="公司地址") 
              .width-680 {{ mchDetail.business_address || '未填写' }}
            el-form-item(label="")
              el-button(type="primary", @click="showEditContact") 修改
          hr
          h4 责任人联系方式
          el-row(:gutter="10")
            el-form-item(label="联系人手机号") 
              .width-680 {{ mchDetail.resp_per_telephone_no || '未填写'| desensitization }}
              el-button(type="primary", @click="toSetPhone") 修改绑定手机
            el-form-item(label="联系人电子邮箱") 
              .width-680 {{ mchDetail.resp_per_email || '未填写' }}
            el-form-item(label="")
              el-button(type="primary", @click="toSetEmail") 
                span(v-if="mchDetail.resp_per_email") 修改绑定邮箱
                span(v-else) 绑定邮件

        template(v-if="mchDetail.type === 2")
          h4 个人联系方式
          el-row(:gutter="10")
            el-col(:span="12")
              el-form-item(label="联系地址") {{ mchDetail.business_address || '未填写' }}
              el-form-item(label="")
                el-button(type="primary", @click="showEditContact") 修改联系地址
              el-form-item(label="手机",required) {{ mchDetail.resp_per_telephone_no || '未绑定' | desensitization}}
              el-form-item(label="") 
                el-button(type="primary", @click="toSetPhone") 修改手机号码
            el-col(:span="12")
              el-form-item(label="") &nbsp;
              el-form-item(label="") &nbsp;
              el-form-item(label="邮箱") {{ mchDetail.resp_per_email || '未绑定' }}
              el-form-item(label="") 
                el-button(type="primary", @click="toSetEmail") 修改邮箱地址

    el-dialog(title="修改联系方式", :visible.sync="editContact.show")
      el-form(:model="editContact", label-position="right", label-width="125px")
        el-form-item(label="联系地址", required)
          el-input(v-model="editContact.business_address")
        el-form-item(label="商户电话", required, v-if="editContact.type === 1")
          el-input(v-model="editContact.tel")
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="saveEditContact()") 保存
        el-button(@click="hideEditContact()") 取消
    
    verifier(ref="verifyEmail", @success_verify="toModifyEmail", scene="MODIFY_EMAIL", opt="MCH_VERIFY")
    verifier(ref="modifyEmail", @success_bind="modifyEmailSuccess", scene="MODIFY_EMAIL", opt="MCH_BINDING", method="email", is-modify)
    verifier(ref="bindingEmail", @success_bind="modifyEmailSuccess", scene="MODIFY_EMAIL", opt="MCH_BINDING", method="email", is-binding)

    verifier(ref="verifyPhone", @success_verify="toModifyPhone", scene="MODIFY_MOBILE", opt="MCH_VERIFY")
    verifier(ref="modifyPhone", @success_bind="modifyPhoneSuccess", scene="MODIFY_MOBILE", opt="MCH_BINDING", method="phone", is-modify)
    verifier(ref="bindingPhone", @success_bind="modifyPhoneSuccess", scene="MODIFY_MOBILE", opt="MCH_BINDING", method="phone", is-binding)

    verifier(ref="editContact", @success_verify="toSaveEditContact", scene="MODIFY_CONTACT", opt="MCH_VERIFY")
</template>

<script>
export default {
  data() {
    return {
      mchDetail: {},
      change_apply_pic: [],
      editContact: {
        show: false,
        type: 1,
        business_address: null,
        tel: null,
      },
      mch_public_draft_list: [{ legal_per_name: "" }],
      loading: false,
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
    isMobile() {
      return window.browserInfo.isMobile;
    },
  },
  filters: {
    type(source) {
      switch (source) {
        case 1:
          return "公司";
        case 2:
          return "个人";
        default:
          return source;
      }
    },
    status(source) {
      if (!source && source !== 0) {
        return "-";
      }
      switch (parseInt(source)) {
        case 1:
          return "填写中";
        case 2:
          return "审批中";
        case 3:
          return "审批通过";
        case 4:
          return "审批失败";
        case 5:
          return "用户撤回修改";
        case 6:
          return "审批中";
        case 7:
          return "审批中";
        default:
          return source;
      }
    },
    settle_type(source) {
      switch (source) {
        case 1:
          return "银行账号";
        case 2:
          return "钱包账号";
        default:
          return source;
      }
    },
    resp_per_id_type(source) {
      switch (source) {
        case "01":
          return "身份证";
        default:
          return "身份证";
      }
    },
  },
  methods: {
    getUserInfo() {
      return this.$store.dispatch("GET_USER_INFO");
    },
    getMchDetail() {
      this.loading = true;
      // const { uname } = this.userInfo;
      return this.$store
        .dispatch("LAST_SUCCEED_MCH_DETAIL")
        .then(async (data) => {
          this.mchDetail = data;
          if (data.change_apply_pic) {
            this.change_apply_pic = data.change_apply_pic.split(",");
          }
          if (data.mch_public_draft_list && data.mch_public_draft_list.length > 0) {
            this.mch_public_draft_list = data.mch_public_draft_list;
          }
          return data;
        })
        .catch(({ code, msg }) => {
          this.$alert(`商家资料获取失败。${code}：${msg}`, {
            type: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    toEdit() {
      this.$router.push("/main/edit");
    },
    showEditContact() {
      this.editContact = {
        show: true,
        type: this.mchDetail.type,
        business_address: this.mchDetail.business_address,
        tel: this.mchDetail.tel,
      };
    },
    hideEditContact() {
      this.editContact = {
        show: false,
        type: 1,
        business_address: null,
        tel: null,
      };
    },
    saveEditContact() {
      if (!this.editContact.business_address) {
        this.$message({
          type: "warning",
          message: `请输入联系地址`,
        });
        return;
      }
      if (this.editContact.type === 1 && !this.editContact.tel) {
        this.$message({
          type: "warning",
          message: `请输入商户电话`,
        });
        return;
      }

      this.$refs.editContact.init();
    },
    toSaveEditContact(biz_ticket) {
      this.loading = true;
      const method =
        this.editContact.type === 1 ? "EDIT_COMPANY_CONTACT" : "EDIT_PERSON_CONTACT";
      this.$store
        .dispatch(method, Object.assign({}, this.editContact, { biz_ticket }))
        .then(() => {
          this.hideEditContact();
          this.getMchDetail();
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `修改失败。${code}：${msg}`,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    revokeEdit(mch_draft_id) {
      this.$confirm("是否确认撤回已提交审批的商家信息？", "提示")
        .then(() => {
          return this.$store
            .dispatch("REVOKE_MCH_DRAFT", mch_draft_id)
            .then(() => {
              this.getMchDetail();

              this.$message({
                type: "success",
                message: "撤回成功",
              });
            })
            .catch(({ code, msg }) => {
              this.$message({
                type: "error",
                message: `撤回失败。${code}：${msg}`,
              });
            });
        })
        .catch(() => {});
    },

    toSetEmail() {
      if (this.mchDetail.resp_per_email) {
        this.toModifyEmail();
      } else {
        this.toBindEmail();
      }
    },
    toBindEmail() {
      this.$refs.bindingEmail.init();
    },
    toModifyEmail(biz_ticket) {
      if (!biz_ticket) {
        this.$refs.verifyEmail.init();
      } else {
        this.biz_ticket = biz_ticket;
        this.$refs.modifyEmail.init(biz_ticket);
      }
    },
    modifyEmailSuccess() {
      this.getMchDetail();
    },

    toSetPhone() {
      if (this.mchDetail.resp_per_telephone_no) {
        this.toModifyPhone();
      } else {
        this.toBindPhone();
      }
    },
    toBindPhone() {
      this.$refs.bindingPhone.init();
    },
    toModifyPhone(biz_ticket) {
      if (!biz_ticket) {
        this.$refs.verifyPhone.init();
      } else {
        this.biz_ticket = biz_ticket;
        this.$refs.modifyPhone.init(biz_ticket);
      }
    },
    modifyPhoneSuccess() {
      this.getMchDetail();
    },
  },
  mounted() {
    // 例如从H5登陆登陆个人高级钱包

    if (this.isMobile) {
      this.$router.replace("/main-mobile");
    }
    this.getUserInfo().then((userInfo) => {
      if (userInfo.fill_info === 1 && this.$route.path !== "/reg/2") {
        this.$router.replace("/reg/2");
      } else {
        this.getMchDetail();
      }
    });
  },
};
</script>
